<template>
  <span :key="`${dateStart}-${dateEnd}`" :class="[$style.root, sameClass]">
    <BaseDateTimeComponent
      class="from"
      :date="dateStart"
      :format="format"
      :locale="locale"
    />
    <span
      :class="$style.seperator"
      v-html="seperator"
    />
    <BaseDateTimeComponent
      class="to"
      :date="dateEnd"
      :format="format"
      :locale="locale"
    />
  </span>
</template>

<script setup>

import dayjs from 'dayjs/esm/index.js'
import utc from 'dayjs/esm/plugin/utc'
import timezone from 'dayjs/esm/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const props = defineProps({
	  dateStart: {
	    type: Date,
	    required: true
	  },
	  dateEnd: {
	    type: Date,
	    required: true
	  },
	  format: {
	    type: String,
	    default: 'DD/MM/YYYY HH:mm'
	  },
	  locale: {
	    type: Object
	  },
	  timezone: {
    type: String,
	    default: 'Europe/Amsterdam'
	  },
	  seperator: {
	    type: String,
	    default: ' – '
	  }
})

const dateStartJs = dayjs.utc(props.dateStart).tz(props.timezone)
const endDateJs = dayjs.utc(props.dateEnd).tz(props.timezone)

// date contains
const hasYear = /Y{1,4}/.test(props.format)
const hasMonth = /M{1,4}/.test(props.format)
const hasDay = /d{1,4}/i.test(props.format)
const hasHour = /h{1,2}/i.test(props.format)
const hasMinute = /m{1,2}/.test(props.format)

// date overlays
const sameYear = hasYear ? dateStartJs.year() === endDateJs.year() : null

let sameMonth = null
if (hasMonth) {
  if (hasYear) {
    sameMonth = dateStartJs.year() === endDateJs.year() && dateStartJs.month() === endDateJs.month()
  } else {
    sameMonth = dateStartJs.month() === endDateJs.month()
  }
}

let sameDay = null
if (hasDay) {
  if (hasYear && hasMonth) {
    sameDay = dateStartJs.year() === endDateJs.year() && dateStartJs.month() === endDateJs.month() && dateStartJs.day() === endDateJs.day()
  } else {
    sameDay = dateStartJs.day() === endDateJs.day()
  }
}

let sameHour = null
if (hasHour) {
  if (hasYear && hasMonth && hasDay) {
    sameHour = dateStartJs.year() === endDateJs.year() && dateStartJs.month() === endDateJs.month() && dateStartJs.day() === endDateJs.day() && dateStartJs.hour() === endDateJs.hour()
  } else {
    sameHour = dateStartJs.hour() === endDateJs.hour()
  }
}

let sameMinute = null
if (hasMinute) {
  if (hasYear && hasMonth && hasDay && hasHour) {
    sameMinute = dateStartJs.year() === endDateJs.year() && dateStartJs.month() === endDateJs.month() && dateStartJs.day() === endDateJs.day() && dateStartJs.hour() === endDateJs.hour() && dateStartJs.minute() === endDateJs.minute()
  } else {
    sameMinute = dateStartJs.minute() === endDateJs.minute()
  }
}

// date classes
const sameYearClass = sameYear ? 'year' : false
const sameMonthClass = sameMonth ? 'month' : false
const sameDayClass = sameDay ? 'day' : false
const sameHourClass = sameHour ? 'hour' : false
const sameMinuteClass = sameMinute ? 'minute' : false

const overLaps = [sameYearClass, sameMonthClass, sameDayClass, sameHourClass, sameMinuteClass].filter(Boolean).join('-')
const sameClass = overLaps ? `same-${overLaps}` : null

</script>

<style module>
	.root {
	}

	.seperator {
	}
</style>
